import { ROLE, User } from '../../types'

export const isProfileCompleteAllowed = (user: User | null) => {
  if (user?.role === ROLE.Babysitter) {
    return !!user?.babysitter_profile
  }
  return true
}
